const AnimatedBackground = () => {
  return (
    <div className="absolute inset-0 -z-10 overflow-hidden">
      {/* Main gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:14px_24px]" />
      </div>

      {/* Animated gradient orbs */}
      <div className="absolute left-[0%] right-[50%] top-[0%] bottom-[50%] bg-gradient-to-r from-blue-200/20 to-cyan-200/20 blur-3xl rounded-full animate-pulse" />
      <div className="absolute left-[50%] right-[0%] top-[50%] bottom-[0%] bg-gradient-to-r from-purple-200/20 to-pink-200/20 blur-3xl rounded-full animate-pulse delay-700" />
      
      {/* Floating elements */}
      <svg className="absolute w-full h-full opacity-30" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: "#60A5FA", stopOpacity: 0.2 }} />
            <stop offset="100%" style={{ stopColor: "#3B82F6", stopOpacity: 0.1 }} />
          </linearGradient>
        </defs>
        
        {/* Animated paths */}
        <path
          d="M-100 200 Q 150 150 400 200 T 900 200"
          fill="none"
          stroke="url(#grad1)"
          strokeWidth="100"
        >
          <animate
            attributeName="d"
            values="M-100 200 Q 150 150 400 200 T 900 200;M-100 200 Q 150 250 400 200 T 900 200;M-100 200 Q 150 150 400 200 T 900 200"
            dur="20s"
            repeatCount="indefinite"
          />
        </path>
        
        <path
          d="M-100 400 Q 150 350 400 400 T 900 400"
          fill="none"
          stroke="url(#grad1)"
          strokeWidth="100"
          opacity="0.5"
        >
          <animate
            attributeName="d"
            values="M-100 400 Q 150 350 400 400 T 900 400;M-100 400 Q 150 450 400 400 T 900 400;M-100 400 Q 150 350 400 400 T 900 400"
            dur="15s"
            repeatCount="indefinite"
          />
        </path>
      </svg>

      {/* Subtle noise texture */}
      <div className="absolute inset-0 bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIHR5cGU9ImZyYWN0YWxOb2lzZSIgYmFzZUZyZXF1ZW5jeT0iLjc1IiBzdGl0Y2hUaWxlcz0ic3RpdGNoIi8+PGZlQ29sb3JNYXRyaXggdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPjwvZmlsdGVyPjxyZWN0IHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIiBmaWx0ZXI9InVybCgjYSkiIG9wYWNpdHk9IjAuMDUiLz48L3N2Zz4=')] opacity-20" />
    </div>
  );
};

export default AnimatedBackground;